export enum EOrderUser {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
}



export default EOrderUser;
